export default __webpack_public_path__ + "static/media/icon-play-button.db46a667.svg";